import React from "react";
import { BlogMenuItem } from "./BlogMenuItem";
import { LocalizationMessages } from "../../../../localization/messages";
import MenuSection from "../../../../components/Menu/MenuSection";
import { SecondaryMenuHelp } from "../../../SecondaryMenu/SecondaryMenuHelp";
import { UserContextSelectors } from "../../../../redux/selectors";
import { links } from "./Config.resource";
import { useSelector } from "react-redux";
import { ContactUsMenuItem } from "./ContactUsMenu";
import { useIntl } from "react-intl";
import LiveChatMenuItem from "../../../LiveChatMenu/LiveChatMenu";
import HelpWidgetMenu from "../../../HelpWidgetMenu/HelpWidgetMenu";
import { AppFeatures } from "../../../../constants/featureFlags";
import { SettingsMobile } from "../../../../components/Settings/loader";
import { useFeature } from "../../../../hooks/useFeature";

const SecondaryMenuLayout = () => {
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isVip = useSelector(UserContextSelectors.isVip);
  const isSettingsDrawerEnabled = useFeature(AppFeatures.SETTINGS_DRAWER);
  const isHelpWidgetActive = useFeature(AppFeatures.HELP_WIDGET);

  const ChatLinkIsForVipOnly = useFeature(
    AppFeatures.CHAT_LINK_IS_FOR_VIP_ONLY
  );
  const { locale } = useIntl();
  const showChat = ChatLinkIsForVipOnly ? isVip : true;
  return (
    <>
      <MenuSection className="menu-section">
        <BlogMenuItem />
        {isMobile &&
          (isHelpWidgetActive ? (
            <HelpWidgetMenu />
          ) : (
            <>
              <SecondaryMenuHelp
                link={links.help}
                title={LocalizationMessages.help}
              />
              {isAuthenticated && (
                <>
                  {(locale === "en" || locale === "de") && showChat && (
                    <LiveChatMenuItem />
                  )}
                  <ContactUsMenuItem />
                </>
              )}
            </>
          ))}
      </MenuSection>
      {isMobile && (
        <MenuSection className="menu-section">
          {isSettingsDrawerEnabled && <SettingsMobile />}
        </MenuSection>
      )}
    </>
  );
};

export default React.memo(SecondaryMenuLayout);
